import type { FaireProductEntity } from "../../entity_types/product";

export const p_6qvjab9fhx: FaireProductEntity = {
  token: "p_6qvjab9fhx",
  type: "product",
  name: "LM-SP-1000 Sherpa - Red/Black",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/f4fb4ea331f48559191e160d13ea44cd4c93fb9abd595a3653f003a34a80ad44.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f5ba1a41c0347b96e446809789cb1106e22b6fc305f64d86f0a0ca3126472a2.jpeg",
    "https://cdn.faire.com/fastly/3f942cc67958873035c91d35f442e271da49b5ee8938d67cf22ebe1c3622f3d1.jpeg"
  ],
  priceDollars: 39.5,
  description: "This Girlie Girl Originals sweatshirt in red and black is a sherpa-style women's sweatshirt designed for casual wear. It offers comfortable sherpa texture and a bold color contrast that fits the brand’s playful, southern-influenced aesthetic.",
  tags: [],
  msrpDollars: 79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:48.556Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
